import React from "react";

/** The icon, title and one-line explanation at the top of a small dialog. */
const DialogIntro = ({ icon: Icon, title, description, titleId }) => (
  <div className="flex flex-col items-center gap-1 text-center">
    {Icon && (
      <div className="w-12 h-12 rounded-full bg-primary-50 text-primary flex items-center justify-center mb-2">
        <Icon size={24} />
      </div>
    )}
    <h3 id={titleId} className="font-bold text-lg text-dark">
      {title}
    </h3>
    {description && <p className="text-sm text-muted">{description}</p>}
  </div>
);

export default DialogIntro;
